import { Link } from "react-router-dom";
const NavList = (props) => {
  return (
    <li
      onClick={() => props.onNavLinkActiveHandler(props.urlName)}
      className={`${props.cssActiveStyle}   `}
    >
      <Link
        to={props.url}
        className={`hover:scale-95 ${
          !props.cssActiveStyle && "hover:text-btnbgcolor"
        } duration-200 block py-2.5  pl-4 font-medium text-xs pr-0 md:pr-12 flex justify-start items-center`}
      >
        {props.children}
        <span
          className={`mt-0.5   ${
            !props.isOpenNav ? "hidden" : "block"
          } md:block`}
        >
          {props.urlName}
        </span>
      </Link>
    </li>
  );
};
export default NavList;
